import { useTranslation as ust } from 'react-i18next';
import TRANSLATION from '@/i18n/translation';

const useTranslation = (): ((key: keyof typeof TRANSLATION) => string) => {
  const { t } = ust();
  return (key: keyof typeof TRANSLATION) => t(key);
};

export default useTranslation;
